import type { ReduxModuleDefinitionWithActions } from '@/types';
import actionsDefinition, {
  MODAL_HIDE_ACTION,
  MODAL_SHOW_ACTION,
} from './actions/index.js';
import type { Modal, ModalState } from './types.js';

const initialState: ModalState = {
  queued: [],
  displayed: null,
};

const modalReduxDefinition = {
  id: 'modal',
  type: 'redux-module',
  initialState,
  actionReducers: {
    [MODAL_SHOW_ACTION]: (state: ModalState, payload: Modal) => {
      if (state.displayed) {
        return { ...state, queued: [...state.queued, payload] };
      }

      return { ...state, displayed: payload };
    },
    [MODAL_HIDE_ACTION]: (state) => {
      return {
        queued: state.queued.slice(1),
        displayed: state.queued[0] || null,
      };
    },
  },
  actionsDefinition,
  selectorDefinitions: [],
  eventReducers: {},
} as const satisfies ReduxModuleDefinitionWithActions;

export default modalReduxDefinition;
